function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import QBtn from '../btn/QBtn.js';
import QIcon from '../icon/QIcon.js';
import FabMixin from '../../mixins/fab.js';
import { noop } from '../../utils/event.js';
import { mergeSlot } from '../../utils/slot.js';
var anchorMap = {
  start: 'self-end',
  center: 'self-center',
  end: 'self-start'
};
var anchorValues = Object.keys(anchorMap);
export default Vue.extend({
  name: 'QFabAction',
  mixins: [FabMixin],
  props: {
    icon: {
      type: String,
      "default": ''
    },
    anchor: {
      type: String,
      validator: function validator(v) {
        return anchorValues.includes(v);
      }
    },
    to: [String, Object],
    replace: Boolean
  },
  inject: {
    __qFab: {
      "default": function _default() {
        return {
          showing: true,
          __onChildClick: noop
        };
      }
    }
  },
  computed: {
    classes: function classes() {
      var align = anchorMap[this.anchor];
      return this.formClass + (align !== void 0 ? " ".concat(align) : '');
    },
    onEvents: function onEvents() {
      return _objectSpread(_objectSpread({}, this.qListeners), {}, {
        click: this.click
      });
    },
    isDisabled: function isDisabled() {
      return this.__qFab.showing !== true || this.disable === true;
    }
  },
  methods: {
    click: function click(e) {
      this.__qFab.__onChildClick(e);

      this.$emit('click', e);
    }
  },
  render: function render(h) {
    var child = [];

    if (this.$scopedSlots.icon !== void 0) {
      child.push(this.$scopedSlots.icon());
    } else if (this.icon !== '') {
      child.push(h(QIcon, {
        props: {
          name: this.icon
        }
      }));
    }

    if (this.label !== '' || this.$scopedSlots.label !== void 0) {
      child[this.labelProps.action](h('div', this.labelProps.data, this.$scopedSlots.label !== void 0 ? this.$scopedSlots.label() : [this.label]));
    }

    return h(QBtn, {
      "class": this.classes,
      props: _objectSpread(_objectSpread({}, this.$props), {}, {
        noWrap: true,
        stack: this.stacked,
        icon: void 0,
        label: void 0,
        noCaps: true,
        fabMini: true,
        disable: this.isDisabled
      }),
      on: this.onEvents
    }, mergeSlot(child, this, 'default'));
  }
});